/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import {Router} from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-show-group-dialog',
  templateUrl: './show-group-dialog.component.html'
})
export class ShowGroupDialogComponent implements OnInit {
  
  mGroupName: string;
  mItemNames: string[];
  
  constructor(
    private mRouter: Router
  ) {}


  ngOnInit(): void {
    
  }
  
  show(groupName: string, itemNames: string[]): void {
    this.mItemNames = itemNames;
    this.mGroupName = groupName;
    $("#show-group-dialog").modal("show");
  }
  
  hide(): void {
    $("#show-group-dialog").modal("hide");
  }

}
